import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./styles/app.scss";
import { UserStateProvider } from "./views/components/UserStateProvider";
import Login from "./pages/Login";
import Home from "./pages/Home";
import History from "./pages/History";
import SingleHistory from './pages/SingleHistory';
import PdfOrderParser from "./pages/PdfOrderParser";
import DeacomConfirmations from "./pages/DeacomConfirmations";
import RouteAuthorizer from "./views/components/RouteAuthorizer";
import DashboardHome from "./pages/DashboardHome";
import DashboardHistory from "./pages/history/DashboardHistory";
import Feedback from "./pages/feedback/Feedback";
import DashboardSingleHistory from "./pages/history/DashboardSingleHistory";
import SingleFeedback from "./pages/feedback/SingleFeedback";
import HelpRequests from "./pages/help-requests/HelpRequests";
import SingleHelpRequest from "./pages/help-requests/SingleHelpRequest";
import Documents from "./pages/Documents";
import BotSettings from "./pages/BotSettings";
import UserAccounts from "./pages/user-accounts/UserAccounts";
import AddUser from "./pages/user-accounts/AddUser";
import SingleUser from "./pages/user-accounts/SingleUser";
import ChangePassword from "./pages/user-accounts/ChangePassword";
import WhatsChanged from "./pages/WhatsChanged";

if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.href = window.location.href.replace('http:', 'https:');
}

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RouteAuthorizer element={ <Login /> } />,
    },
    {
      path: "/home",
      element: <RouteAuthorizer element={ <Home /> } requireAuth />,
    },
    {
      path: "/history",
      element: <RouteAuthorizer element={ <History /> } requireAuth />,
    },
    {
      path: "/history/:sessionId",
      element: <RouteAuthorizer element={ <SingleHistory /> } requireAuth />,
    },
    {
      path: "/pdf-order-parser",
      element: <RouteAuthorizer element={ <PdfOrderParser /> } requireAuth />,
    },
    {
      path: "/pdf-order-parser/page/:page",
      element: <RouteAuthorizer element={ <PdfOrderParser /> } requireAuth />,
    },
    {
      path: "/pdf-order-parser/deacom-confirmations",
      element: <RouteAuthorizer element={ <DeacomConfirmations /> } requireAuth />,
    },
    {
      path: "/pdf-order-parser/deacom-confirmations/page/:page",
      element: <RouteAuthorizer element={ <DeacomConfirmations /> } requireAuth />,
    },
    {
      path: "/whats-changed",
      element: <RouteAuthorizer element={ <WhatsChanged /> } requireAuth updateUserReleaseVersion />,
    },
    // Dashboard
    {
      path: "/dashboard/home",
      element: <RouteAuthorizer element={ <DashboardHome /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/history",
      element: <RouteAuthorizer element={ <DashboardHistory /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/history/:sessionId",
      element: <RouteAuthorizer element={ <DashboardSingleHistory /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/history/page/:page",
      element: <RouteAuthorizer element={ <DashboardHistory /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/history/page/:page/:tab",
      element: <RouteAuthorizer element={ <DashboardHistory /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/feedback",
      element: <RouteAuthorizer element={ <Feedback /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/feedback/:id",
      element: <RouteAuthorizer element={ <SingleFeedback /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/feedback/page/:page",
      element: <RouteAuthorizer element={ <Feedback /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/feedback/page/:page/:rating",
      element: <RouteAuthorizer element={ <Feedback /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/help-requests",
      element: <RouteAuthorizer element={ <HelpRequests /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/help-requests/:id",
      element: <RouteAuthorizer element={ <SingleHelpRequest /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/help-requests/page/:page",
      element: <RouteAuthorizer element={ <HelpRequests /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/help-requests/page/:page/:status",
      element: <RouteAuthorizer element={ <HelpRequests /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/documents",
      element: <RouteAuthorizer element={ <Documents /> } requireAuth capability="read_documents" />,
    },
    {
      path: "/dashboard/documents/page/:page",
      element: <RouteAuthorizer element={ <Documents /> } requireAuth capability="read_documents" />,
    },
    {
      path: "/dashboard/bot-settings",
      element: <RouteAuthorizer element={ <BotSettings /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/user-accounts",
      element: <RouteAuthorizer element={ <UserAccounts /> } requireAuth capability="read_user_accounts" />,
    },
    {
      path: "/dashboard/user-accounts/page/:page",
      element: <RouteAuthorizer element={ <UserAccounts /> } requireAuth capability="read_user_accounts" />,
    },
    {
      path: "/dashboard/user-accounts/add",
      element: <RouteAuthorizer element={ <AddUser /> } requireAuth capability="create_user" />,
    },
    {
      path: "/dashboard/user-accounts/:id",
      element: <RouteAuthorizer element={ <SingleUser /> } requireAuth capability="read_dashboard" />,
    },
    {
      path: "/dashboard/user-accounts/change-password",
      element: <RouteAuthorizer element={ <ChangePassword /> } requireAuth user capability="read_dashboard" />,
    },
  ]);

  return(
    <UserStateProvider>
      <RouterProvider router={ router } />
    </UserStateProvider>
  );
}

export default App;
